import type { BopCarBop, GetBopForTrackerTableQuery } from "../generated/gql/graphql";

export type EngineBoostCurve = Record<string, number | null>;

export type CarSpecBopMap = {
  bopName: string;
  highlightColour?: string;
  boost: Map<string, EngineBoostCurve>;
  sessions: Map<string, BopCarBop>;
};

// Mapping the per session bop data to per car bop data, keeping the last entered highlight colour
export const groupByCarSpec = (sessions: GetBopForTrackerTableQuery["sessions"]): Map<string, CarSpecBopMap> => {
  const carSpecBopMap = new Map<string, CarSpecBopMap>();

  sessions?.items?.forEach(session => {
    const allCarBops = session.bop?.carBop;

    allCarBops?.forEach(carBop => {
      const bopName = carBop?.carSpec;
      if (!bopName) return;

      if (!carSpecBopMap.has(bopName)) {
        carSpecBopMap.set(bopName, {
          bopName,
          highlightColour: carBop.highlightColour || undefined,
          sessions: new Map(),
          boost: new Map(),
        });
      } else {
        const original = carSpecBopMap.get(bopName);

        if (original) {
          original.highlightColour = carBop.highlightColour || undefined;

          carSpecBopMap.set(bopName, original);
        }
      }

      carSpecBopMap.get(bopName)?.sessions.set(session._id, carBop);
      carSpecBopMap.get(bopName)?.boost.set(session._id, (carBop.pEngineBoost as unknown as EngineBoostCurve) ?? {});
    });
  });

  return carSpecBopMap;
};
